var map = {
	"./trucks/box3/battery.webp": 833,
	"./trucks/box3/coolant.webp": 390,
	"./trucks/box3/fuelPort.webp": 935,
	"./trucks/box3/headLight.webp": 370,
	"./trucks/box3/ignition.webp": 79,
	"./trucks/box3/lampAndLiftSwitch.webp": 714,
	"./trucks/box3/licenseLight.webp": 369,
	"./trucks/box3/liftGateSwitch.webp": 606,
	"./trucks/box3/liftGateUnfold1.webp": 329,
	"./trucks/box3/liftGateUnfold2.webp": 364,
	"./trucks/box3/oil.webp": 240,
	"./trucks/box3/raiseCab1.webp": 769,
	"./trucks/box3/raiseCab2.webp": 404,
	"./trucks/box3/rear.webp": 890,
	"./trucks/box3/reverseLight.webp": 998,
	"./trucks/box3/sideRearTop.webp": 776,
	"./trucks/box3/tire.webp": 114,
	"./trucks/box3/tireInner.webp": 821,
	"./trucks/box3/tireOuter.webp": 585,
	"./trucks/box3/topFront.webp": 222,
	"./trucks/box3/transmissionFluid.webp": 900,
	"./trucks/box3/wiperFluid.webp": 565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 958;